module.exports = __webpack_public_path__ + "img/20.5dccfe10.jpg";